import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseOrderLabForm } from "@/features/purchase-orders/purchase-order-form";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreatePurchaseOrderLab = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      await apiOutletClient.post("purchase-orders/lab", formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat pesanan pembelian lensa")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pesanan Pembelian Lab."
      breadcrumbs={[
        { title: "Pesanan Pembelian Lab", path: "/procurement/purchase-orders/lab" },
        { title: "Tambah" },
      ]}
    >
      <PurchaseOrderLabForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
